import { useState } from "react";
import ViewDetails from "./ViewDetails";
import { Modal } from "./Handlers/StatusHandlers";
import { downloadMedicalReportFe, updateViewReportStatus } from "../../services/epic/medicalReport";
import DownloadReport from "./DownloadReport";
import { capitalizeFirstLetter, isMobileApp, openPdfToUrl } from "../../utils/util";
import { MedicalReportStatus } from "../../utils/constants";

const MedicalReportCard = ({ medicalReport, translationMap, setShowCardDownLoadSuccess, showCardDownLoadSuccess }) => {
  const [state, setState] = useState(false);
  const [showDownLoadSuccess, setShowDownLoadSuccess] = useState(false);

  const handleClick = () => {
    setState(true);
    setShowDownLoadSuccess(false);
    setShowCardDownLoadSuccess(false);
  };

  const closeModal = () => {
    setState(false);
    setShowDownLoadSuccess(false);
    setShowCardDownLoadSuccess(false);
  };

  const downloadReport = async (e, isFromCard) => {
    const requestBody = { medicalReportId: medicalReport?.id };

    const button = e.target.closest('.downloadReportMr');
    button.classList.add("active");

    try {
      const promises = [downloadMedicalReportFe(requestBody)];

      if (medicalReport?.isNotSeen === true) {
        let updateRequestBody = { medicalReportId: medicalReport?.id, isNotSeen: false };
        promises.push(updateViewReportStatus(updateRequestBody));
      }
      const [result] = await Promise.all(promises);
      const downloadBase64Result = result.data.base64file;
      const downloadLink = document.createElement('a');
      downloadLink.href = `data:application/pdf;base64,${downloadBase64Result}`;
      downloadLink.download = 'MedicalReportRequest.pdf';
      if (isMobileApp()) {
        setTimeout(() => {
          button.classList.remove("active");
          let cardUrl = openPdfToUrl(downloadBase64Result);
          window.open(cardUrl, "_parent");
          const link = document.createElement("a");
          link.href = cardUrl;
          link.download = "MedicalReportRequest.pdf";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          if (isFromCard) {
            setShowCardDownLoadSuccess(true);
          } else {
            setShowDownLoadSuccess(true);
          }
        }, 2000);
      } else {
        setTimeout(() => {
          button.classList.remove("active");
          button.querySelector("i").classList.replace("fa-download", "fa-check");
          button.querySelector("span").innerText = translationMap?.downloaded;
          button.classList.add("download1");
          downloadLink.click();
          if (isFromCard) {
            setShowCardDownLoadSuccess(true);
          } else {
            setShowDownLoadSuccess(true);
          }
        }, 3500);
      }
    } catch (err) {
      console.error("Download or update failed:", err);
      button.classList.remove("active");

    }
  };

  const dateConvert = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "long",
      year: "numeric"
    });
  };
  const statusToIconClass = {
    initiated: "yellow_icon",
    completed: "active_icon",
    failed: "orange_icon",
    rejected: "orange_icon",
    processed: "yellow_icon"
  };
  const statusMessageObj = {
    initiated: translationMap?.initiated,
    completed: translationMap?.completed,
    failed: translationMap?.failed,
    processed: translationMap?.inProgress,
    cancelled: translationMap?.cancelled,
    rejected: translationMap?.rejected
  };

  const iconClass = statusToIconClass[medicalReport?.medicalReportStatus?.toLowerCase()] || "orange_icon";
  const statusMessage = statusMessageObj[medicalReport?.medicalReportStatus?.toLowerCase()] || "Cancelled";

  return (
    <>
            <div className="Sick_leave_white_box">
                <div className="sick_inner_box1">
                    <div className="date_box">
                        <svg width="20" height="22" viewBox="0 0 20 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                d="M7 17.5L13 17.5M5 14L15 14M3 1L17 1C18.1046 1 19 1.99492 19 3.22222L19 18.7778C19 20.0051 18.1046 21 17 21L3 21C1.89543 21 1 20.0051 1 18.7778L1 3.22222C1 1.99492 1.89543 1 3 1ZM9.9976 5.21194C9.29783 4.4328 8.13091 4.22321 7.25414 4.93667C6.37738 5.65013 6.25394 6.84299 6.94247 7.6868C7.631 8.53061 9.9976 10.5 9.9976 10.5C9.9976 10.5 12.3642 8.53061 13.0527 7.6868C13.7413 6.84299 13.6329 5.64262 12.7411 4.93667C11.8492 4.23072 10.6974 4.4328 9.9976 5.21194Z"
                stroke="#002F70" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                        {/* <span className="material-symbols-outlined"><img src="/images/heart-icon.png"/></span> */}
                    </div>
                    <div className="content_box">
                        <p className="active">
                            <span className={`circle_icon ${iconClass}`}></span>
                            {statusMessage}
                        </p>
                        <h6 className="name_txt">{capitalizeFirstLetter(medicalReport.doctorName)}</h6>
                        <ul className="detail_ul_box detail_ul_box2">
                            <li>
                                <p>
                                    <span>{translationMap?.visitDate}:&nbsp;</span>
                                    <p style={{ direction: "ltr" }}>{dateConvert(medicalReport.visitDate)}</p>
                                </p>
                            </li>
                            <li>
                                <p>
                                    <span>{translationMap?.specialty}:&nbsp;</span>
                                    <p>{medicalReport.specialtyName}</p>
                                </p>
                            </li>
                        </ul>
                        <ul className="detail_ul_box detail_ul_box2">
                            <li>
                                <p>
                                    <span>{translationMap?.requestDate}:&nbsp;</span>
                                    <p style={{ direction: "ltr" }}>
                                        {dateConvert(medicalReport.requestDate)}
                                    </p>
                                </p>
                            </li>
                            <li>
                                <p>
                                    <span>{translationMap?.requestNo}:&nbsp;</span>
                                    <p>{medicalReport?.refNumber}</p>
                                </p>
                            </li>
                        </ul>
                    </div>
                </div>
                <div className="sick_inner_box2">
                    <div className="btn_innerwrap">
                        {
            medicalReport.medicalReportStatus === MedicalReportStatus.completed &&
            medicalReport.filenetVSID && medicalReport.filenetVSID !== 'null' && medicalReport.filenetVSID !== null && medicalReport.filenetVSID !== undefined ?
            isMobileApp() ?
            <DownloadReport downloadReport={downloadReport} translationMap={translationMap}
            card={true} classbutton={"button3"} /> :

            <DownloadReport downloadReport={downloadReport} translationMap={translationMap}
            card={true} /> :

            null
            }

                        <ViewDetails medicalReport={medicalReport} handleClick={handleClick}
            translationMap={translationMap} />
                    </div>
                </div>
            </div>
            {state && <Modal medicalReport={medicalReport} closeModal={closeModal} downloadReport={downloadReport}
      translationMap={translationMap} showDownLoadSuccess={showDownLoadSuccess} showCardDownLoadSuccess={showCardDownLoadSuccess} />}
        </>);

};

export default MedicalReportCard;